var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("h2", { staticClass: "h5 block-title text-center my-5" }, [
        _vm._v("Your payment was canceled."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }